import { baseApi } from "../baseApi";

const ADJUSTMENT_BASE_URL = "adjustments";

export const adjustmentApi = baseApi.injectEndpoints({
  tagTypes: ["Adjustment"],

  endpoints: (build) => ({
    createAdjustment: build.mutation({
      query: (body) => ({
        url: ADJUSTMENT_BASE_URL,
        method: "POST",
        body,
      }),
    }),

    listAdjustment: build.query({
      query: (params) => ({
        url: ADJUSTMENT_BASE_URL,
        params,
      }),
      providesTags: (result) =>
        result?.data
          ? [
              ...result?.data?.map(({ _id }) => ({ type: "Adjustment", _id })),
              { type: "Adjustment", id: "LIST" },
            ]
          : [{ type: "Adjustment", id: "LIST" }],
    }),

    getAdjustmentDetail: build.query({
      query: (id) => `${ADJUSTMENT_BASE_URL}/${id}`,
      providesTags: (result, error, id) => [
        { type: "Adjustment", id },
        { type: "Adjustment", id: "LIST" },
      ],
    }),

    updateAdjustment: build.mutation({
      query: (payload) => {
        const { _id, ...body } = payload;
        return {
          url: `${ADJUSTMENT_BASE_URL}/${_id}`,
          method: "PUT",
          body,
        };
      },
      invalidatesTags: (result, error, { _id }) => [
        { type: "Adjustment", _id },
        { type: "Adjustment", id: "LIST" },
      ],
    }),
    getAdjustmentDDL: build.query({
      query: (params) => {
        return { url: `${ADJUSTMENT_BASE_URL}/ddl`, params };
      },
      providesTags: (result, error, id) => [
        { type: "Adjustment", id },
        { type: "Adjustment", id: "LIST" },
      ],
    }),
  }),
});

export const {
  useCreateAdjustmentMutation,

  useLazyListAdjustmentQuery,

  useAdjustmentDetailQuery,

  useUpdateAdjustmentMutation,

  useGetAdjustmentDetailQuery,

  useLazyGetAdjustmentDDLQuery,
} = adjustmentApi;
